import { Integrations } from '@sentry/tracing';

// tracing must come before react for sentry
import * as Sentry from '@sentry/react';
import { AppSettings } from 'settings/AppSettings';
import { ignoredMessages } from '@tock/logging';
import TockHistory from 'utils/TockHistory';

export function initSentry(appSettings: AppSettings, history: TockHistory) {
  if (appSettings.DATADOG_ENV !== 'staging') {
    return;
  }
  Sentry.init({
    dsn: 'https://140754ddffbf4b00aee0b28b44a19b37@o954883.ingest.sentry.io/5904183',
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
      }),
    ],
    ignoreErrors: ignoredMessages,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    release: (window as any).__BUILD_NUMBER__ ?? 'dev',
    environment: appSettings.DATADOG_ENV,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.25,
    attachStacktrace: true,
  });
}
